import _typeof from "@babel/runtime/helpers/esm/typeof";
var onClient = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object';
var onServer = !onClient;
export default {
  onClient: onClient,
  onServer: onServer
};